<div
  *ngIf="!is_summary_request_running"
  class="sp-border-radius__s sp-position__relative"
  [ngClass]="item_class">
  <div
    class="sp-padding__x2"
    [ngClass]="label_class">
    <p class="sp-color__primary-medium sp-margin__no sp-text__ellipsized">
      {{ item_label || '-' | translate }}
    </p>

    <h2
      class="sp-margin__no sp-text__ellipsized"
      [ngClass]="value_class">
      {{ item_value }} {{ value_suffix }}
    </h2>
  </div>

  <!--<h6
    class="sp-color__primary sp-position__absolute sp-position__bottom sp-position__right-x2"
    [ngClass]="label_class">
    <i>({{ 'GENERAL.LAST_3_MONTHS_LABEL' | translate }})</i>
  </h6>-->
</div>

<app-loading
  *ngIf="is_summary_request_running"
  [card_radius]="'sp-border-radius__s'"></app-loading>
